import { useState, useCallback } from 'react';
import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';

interface PrintersFiltersState {
  status: string[];
  active: string[];
}

export const usePrintersFilters = ({
  initialConditions,
  onChange,
}: {
  initialConditions: FilterConditionOutput[];
  onChange?: (conditions: FilterConditionOutput[]) => void;
}) => {
  const parseConditions = (conditions: FilterConditionOutput[]): PrintersFiltersState => {
    const state: PrintersFiltersState = {
      status: [],
      active: [],
    };

    conditions.forEach((condition) => {
      if (condition.column === 'status') {
        if (condition.action === 'equals') {
          state.status = [condition.value as string];
        } else if (condition.action === 'in') {
          state.status = condition.value as string[];
        }
      }
      if (condition.column === 'active') {
        if (condition.action === 'equals') {
          state.active = [condition.value as string];
        } else if (condition.action === 'in') {
          state.active = condition.value as string[];
        }
      }
    });

    return state;
  };

  const [filters, setFilters] = useState<PrintersFiltersState>(() => parseConditions(initialConditions));

  const convertToConditions = useCallback((state: PrintersFiltersState) => {
    const conditions: FilterConditionOutput[] = [];

    if (state.status.length > 0) {
      if (state.status.length === 1) {
        conditions.push({
          column: 'status',
          action: 'equals',
          value: state.status[0],
        });
      } else {
        conditions.push({
          column: 'status',
          action: 'in',
          value: state.status,
        });
      }
    }

    if (state.active.length > 0) {
      if (state.active.length === 1) {
        conditions.push({
          column: 'active',
          action: 'equals',
          value: state.active[0],
        });
      } else {
        conditions.push({
          column: 'active',
          action: 'in',
          value: state.active,
        });
      }
    }

    return conditions;
  }, []);

  const handleFilterChange = (key: keyof PrintersFiltersState, value: any) => {
    setFilters((prev) => {
      const next = { ...prev, [key]: value };
      onChange?.(convertToConditions(next));
      return next;
    });
  };

  const clearFilters = () => {
    const next = {
      status: [],
      active: [],
    };
    setFilters(next);
    onChange?.(convertToConditions(next));
  };

  return {
    filters,
    handleFilterChange,
    clearFilters,
  };
};
